import api from './api';

export async function fetchRequestWorkflows() {
  const res = await api.get('/super-admin/hr-request-workflows');
  return res.data;
}

export async function fetchRequestWorkflowGuides() {
  const res = await api.get('/hr-request-workflows');
  return res.data;
}

export async function updateRequestWorkflow(requestType, payload) {
  const res = await api.put(`/super-admin/hr-request-workflows/${requestType}`, payload);
  return res.data;
}

export async function saveRequestWorkflowDraft(requestType, payload) {
  const res = await api.put(`/super-admin/hr-request-workflows/${requestType}/draft`, payload);
  return res.data;
}

export async function validateRequestWorkflow(requestType, payload) {
  const res = await api.post(`/super-admin/hr-request-workflows/${requestType}/validate`, payload);
  return res.data;
}

export async function simulateRequestWorkflow(requestType, payload) {
  const res = await api.post(`/super-admin/hr-request-workflows/${requestType}/simulate`, payload);
  return res.data;
}

export async function simulatePublishedRequestWorkflow(requestType, sampleData = {}) {
  const res = await api.post(`/hr-request-workflows/${requestType}/simulate`, {
    sample_data: sampleData,
  });
  return res.data;
}

export async function publishRequestWorkflow(requestType) {
  const res = await api.post(`/super-admin/hr-request-workflows/${requestType}/publish`);
  return res.data;
}

export async function resetRequestWorkflow(requestType) {
  const res = await api.delete(`/super-admin/hr-request-workflows/${requestType}`);
  return res.data;
}
